import { Component } from '@angular/core';

@Component({
  selector: 'my-log-user',
  template: require('./logUser.component.html')
})
export class LogUserComponent {

  constructor() {
    // Do stuff
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/adminUser/logUser/logUser.component.ts